'use es6';

import Immutable from 'immutable';
import * as Tiers from 'ecosystem-marketplace-core/constants/groupTags/Tier';
import * as TierGroups from 'ecosystem-marketplace-core/constants/groupTags/TierGroup';
const MARKETING = 'marketing';
const SALES = 'sales';
const SERVICE = 'service';
const CMS = 'cms';
const OPS = 'ops';
const TierGroup = Immutable.Record({
  key: '',
  tiers: Immutable.OrderedSet()
});
const ORDER = Immutable.OrderedSet([Tiers.HUBSPOT_FREE, TierGroup({
  key: MARKETING,
  tiers: Immutable.OrderedSet(TierGroups.MARKETING)
}), TierGroup({
  key: SALES,
  tiers: Immutable.OrderedSet(TierGroups.SALES)
}), TierGroup({
  key: SERVICE,
  tiers: Immutable.OrderedSet(TierGroups.SERVICE)
}), TierGroup({
  key: CMS,
  tiers: Immutable.OrderedSet(TierGroups.CMS)
}), TierGroup({
  key: OPS,
  tiers: Immutable.OrderedSet(TierGroups.OPERATIONS)
})]);
export { TierGroup, ORDER };